import { useCallback } from "react";

import { useGenomeViewerStore } from "../../../../store/store.ts";

export const useClose = () =>
  useCallback(() => {
    const contextualMenu: HTMLDivElement = document.querySelector("#genome-viewer-contextual-menu")!;
    Object.assign(contextualMenu.style, {
      display: "none",
    });
    useGenomeViewerStore.setState({ showFeaturePopover: false, contextualMenuData: undefined });
  }, []);
